import { NgModule } from '@angular/core';
import { ToggleDirective } from './toggle.directive';
import { UiDragScrollDirective } from './ui-drag-scroll.directive';
import { UiWheelScrollDirective } from './ui-wheel-scroll.directive';

@NgModule({
  declarations: [ToggleDirective, UiDragScrollDirective, UiWheelScrollDirective],
  exports: [ToggleDirective, UiDragScrollDirective, UiWheelScrollDirective],
})
export class DirectivesModule {}
